/* eslint-disable */

import Vue from 'vue'
import Vuex from 'vuex'

import moduleJWT from './modules/JsonWebToken/store';
import moduleUser from './modules/User/store';
import moduleAdvertiser from './modules/Advertiser/store';
import moduleRewards from './modules/Rewards/store';
import moduleCounts from './modules/Counts/store';
import moduleModal from './modules/Modal/store';
import moduleUniversities from './modules/Universities/store';

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    jwt: moduleJWT,
    user: moduleUser,
    advertiser: moduleAdvertiser,
    rewards: moduleRewards,
    counts: moduleCounts,
    modal: moduleModal,
    universities: moduleUniversities,
  },
  state: {
    first_time: false,
    time_period: "Last 30 Days",
    count_type: "Total Redemptions",
    endpoints: {
      initialData: 'https://stormy-mountain-29119.herokuapp.com/v3/initial_data/',
      passwordReset: 'https://stormy-mountain-29119.herokuapp.com/v3/password/reset/',
      passwordResetConfirm: 'https://stormy-mountain-29119.herokuapp.com/v3/password/reset/confirm/',
      billing: 'https://stormy-mountain-29119.herokuapp.com/v3/billing/',
      billingCreateCheckoutSession: 'https://stormy-mountain-29119.herokuapp.com/v3/billing/create_checkout_session',
      billingCompleteCheckoutSession: 'https://stormy-mountain-29119.herokuapp.com/v3/billing/complete_checkout_session',
      signUp: 'https://stormy-mountain-29119.herokuapp.com/v3/signup/',
      feedback: 'https://stormy-mountain-29119.herokuapp.com/v3/feedback/',
    },
  },
  mutations: {
    clearState(state) {
      state.first_time = false;
      state.time_period = "Last 30 Days";
      state.count_type = "Total Redemptions";
    },
    updateFirstTime(state, newFirstTime) {
      state.first_time = newFirstTime;
    },
    updateTimePeriod(state, newTimePeriod) {
      state.time_period = newTimePeriod;
    },
    updateCountType(state, newCountType) {
      state.count_type = newCountType;
    },
  },
  actions: {
    clearState(context) {
      this.commit('clearState');
    },
    updateFirstTime(context, newFirstTime) {
      this.commit('updateFirstTime', newFirstTime);
    },
    updateTimePeriod(context, newTimePeriod) {
      this.commit('updateTimePeriod', newTimePeriod);
    },
    updateCountType(context, newCountType) {
      this.commit('updateCountType', newCountType);
    },
  },
  getters: {
    firstTime: (state) => {
      return state.first_time;
    },
    timePeriod: (state) => {
      return state.time_period;
    },
    countType: (state) => {
      return state.count_type;
    },
  },
})
